import NumericText from "@/components/NumericText";
import { memo } from "react";

interface StatCardProps {
  label: string;
  value: string | number;
  suffix?: string;
  variant?: "default" | "warning";
}

export const StatCard = memo(function StatCard({
  label,
  value,
  suffix,
  variant = "default",
}: StatCardProps) {
  const isWarning = variant === "warning";

  return (
    <div
      className={`w-full rounded-md border p-3.5 text-center transition-shadow hover:shadow-sm ${
        isWarning
          ? "bg-[#FEF3F2] border-[#FEE2E2]"
          : "bg-[#F9FAFB] border-[#E5E7EB]"
      }`}
    >
      <NumericText
        className={`text-[28px] font-bold leading-none mb-1.5 ${
          isWarning ? "text-[#DC2626]" : "text-[#111827]"
        }`}
      >
        {value}
      </NumericText>
      {suffix && (
        <div className="text-[10px] text-[#6B7280] font-semibold uppercase tracking-[0.8px]">
          {suffix}
        </div>
      )}
      <div className="text-[10px] text-[#6B7280] font-semibold uppercase tracking-[0.8px]">
        {label}
      </div>
    </div>
  );
});
